import { type ReactElement } from 'react';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Descriptions, Card, Grid } from 'antd';

import type { AdminCustomerOrder } from '@/types';

const { useBreakpoint } = Grid;

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function formatCents(cents: number | null): string {
  if (cents === null || cents === undefined) return '—';
  return `$${(cents / 100).toFixed(2)}`;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function CustomerOrderShow(): ReactElement {
  const { query } = useShow<AdminCustomerOrder>();
  const record = query.data?.data;
  const isLoading = query.isLoading;

  const screens = useBreakpoint();
  const descColumns = screens.md ? 2 : 1;

  return (
    <Show isLoading={isLoading}>
      {record && (
        <Card>
          <Descriptions bordered column={descColumns} size="small">
            <Descriptions.Item label="ID">{record.id}</Descriptions.Item>

            <Descriptions.Item label="Customer ID">
              <a href={`/customers/show/${record.customerId}`}>
                {record.customerId}
              </a>
            </Descriptions.Item>

            <Descriptions.Item label="Order ID">
              <a href={`/orders/show/${record.orderId}`}>{record.orderId}</a>
            </Descriptions.Item>

            <Descriptions.Item label="Order Date">
              {new Date(record.orderDate).toLocaleDateString()}
            </Descriptions.Item>

            <Descriptions.Item label="Product Type">
              {record.productType ?? '—'}
            </Descriptions.Item>

            <Descriptions.Item label="Amount Paid">
              {formatCents(record.amountPaid)}
            </Descriptions.Item>

            <Descriptions.Item label="Currency">
              {record.currency}
            </Descriptions.Item>

            <Descriptions.Item label="Created At">
              {new Date(record.createdAt).toLocaleString()}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
    </Show>
  );
}
